const YM_COUNTER_ID = 104258304

let lastSentUserId = null

export const sendYandexUserId = (userId) => {
  if (typeof window === 'undefined' || !userId) {
    return
  }

  if (typeof window.ym !== 'function') {
    return
  }

  const normalizedUserId = String(userId)

  if (!normalizedUserId || normalizedUserId === lastSentUserId) {
    return
  }

  window.ym(YM_COUNTER_ID, 'setUserID', normalizedUserId)
  window.ym(YM_COUNTER_ID, 'userParams', {
    UserID: normalizedUserId,
    internal_user_id: normalizedUserId
  })

  lastSentUserId = normalizedUserId
}

export const sendYandexGoal = (goalName, params = null) => {
  if (typeof window === 'undefined' || typeof window.ym !== 'function') {
    return
  }

  if (!goalName || typeof goalName !== 'string') {
    return
  }

  if (params && typeof params === 'object') {
    window.ym(YM_COUNTER_ID, 'reachGoal', goalName, params)
    return
  }

  window.ym(YM_COUNTER_ID, 'reachGoal', goalName)
}

export const resetYandexUserIdSync = () => {
  lastSentUserId = null
}
